<template>
    <Head>
        <title>Resit anda sedang disediakan. Sila tunggu</title>
        <link rel="shortcut apple-touch-icon icon" :href="img_favicon" type="image/png">
    </Head>
    <div style="width: 100vw;">
        <div class="col">
            <section class="alert alert-success py-3" role="alert">
                <p class="fs-3 text-center">
                    <b>Pembayaran anda berjaya...Tunggu sebentar</b><br>
                    Membawa ke halaman resit

                </p>
            </section>
        </div>
    </div>
</template>
<script setup lang="ts">
import {onMounted} from "vue";
import {Head} from "@inertiajs/vue3";

const data = defineProps<{
    img_favicon: string,
    razeripn: string,
    uri: string,
}>();

onMounted(()=>{
    document.getElementsByTagName("body")[0].style.width = "100%";
    document.getElementsByTagName("body")[0].style.display = "grid";
    document.getElementsByTagName("body")[0].style.placeItems = "center";
    document.getElementsByTagName("html")[0].style.width = "100%";
    document.getElementsByTagName("html")[0].style.height = "100%";
    document.getElementsByTagName("body")[0].style.height = "100%";

    let m = document.createElement("IFRAME");
    m.setAttribute("src", data.razeripn);
    m.setAttribute("seamless", "seamless");
    m.setAttribute("width", String(0));
    m.setAttribute("height", String(0));
    m.setAttribute("frameborder", String(0));
    m.setAttribute("scrolling", "no");
    m.setAttribute("style", "border:none !important;");
    document.body.appendChild(m);
    setTimeout( () => window.location.href = data.uri, 1000);
})
</script>
<style></style>
